import { mixpanel } from '@/mixpanel'
import { type CareQuestionOption, useCareQuestionOptions } from '@/modules/care-question/hooks/useCareQuestionOptions'
import { DropdownButton } from '@/modules/shared/components/dropdown-button/DropdownButton'
import { CareQuestionOptionCta } from '../../care-question-option-cta/CareQuestionOptionCta'

import type { FC } from 'react'

type Props = {
  title: string
}

/**
 * Action button for care questions options
 * Displayed as a button with a dropdown (for desktop)
 */
export const CareQuestionDesktopActionButton: FC<Props> = ({ title }) => {
  // Hooks
  // ------------------------------------------------------------------------- /
  const careQuestionOptions = useCareQuestionOptions({ isDesktop: true })

  // Render
  // ------------------------------------------------------------------------- /
  const renderOption = (item: CareQuestionOption, onClose: () => void) => {
    return <CareQuestionOptionCta key={item.id} {...item} onClose={onClose} />
  }
  return (
    <DropdownButton<CareQuestionOption>
      title={title}
      options={careQuestionOptions}
      renderOption={renderOption}
      onOpen={() => {
        mixpanel.track('care_question_open_dropdown')
      }}
      onClose={() => {
        mixpanel.track('care_question_close_dropdown')
      }}
      alignMenu='start'
    />
  )
}
